export default {
    getNewInvitation: (state) => {
        return state.newInvitation
    },
    getStoredInvitation: (state) => {
        return state.invitation
    }
}
